import type { SuggestedAddress, ValidateAddressInput } from '../../../core/models/address-validate';

/**
 * Normalizes postal codes for comparison by trimming, uppercasing, and removing spacing.
 */
export function normalizePostalCodeForComparison(value: string): string {
  return value
    .trim()
    .replace(/[\s-]+/g, '')
    .toUpperCase();
}

/**
 * Returns true when AVS suggested address fields match the submitted validate entry.
 * Compares the same fields as ESN BR-ESN-ADDR-006 (line1, municipality, postal, addressee, province).
 * Suite/addressLine2 is excluded because AVS often omits it when already embedded in line1.
 * Comparison is case-insensitive; postal codes ignore internal spacing and hyphens.
 */
export function suggestedAddressMatchesTypedEntry(
  request: ValidateAddressInput,
  suggestedAddress: SuggestedAddress,
): boolean {
  const compareField = (left: string | undefined, right: string | undefined): boolean =>
    (left ?? '').trim().toUpperCase() === (right ?? '').trim().toUpperCase();

  return (
    compareField(request.addressee, suggestedAddress.addressee) &&
    compareField(request.addressLine1, suggestedAddress.addressLine1) &&
    compareField(request.municipalityName, suggestedAddress.municipalityName) &&
    compareField(request.provinceCode, suggestedAddress.provinceCode) &&
    normalizePostalCodeForComparison(request.postalCode) ===
      normalizePostalCodeForComparison(suggestedAddress.postalCode)
  );
}
